<template>
  <a-modal
    v-model="showModal"
    title="View Conditions description"
    :footer="null"
    width="500px"
    :destroyOnClose="true"
    class="view-add-condition-modal"
  >
    <div v-if="!hasItems" class="mb-3">
      <Empty>
        <span slot="description" class="text-default">None available conditions description</span>
      </Empty>
    </div>
    <a-tabs v-else type="card" class="mb-2">
      <a-tab-pane
        v-for="(translation, index) in translations"
        :key="index"
        force-render
      >
        <template #tab>
          <DefaultLabelTab
            :name="translation.tab_name"
            :is_default="translation.is_default"
          />
        </template>
        <div class="tab-content-container">
          <div
            v-for="item in translation.items"
            :key="item.id"
            class="d-flex"
          >
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center" style="gap: 10px;">
                <div class="dot" />
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-row class="footer-viewscreen footer d-flex justify-content-end">
      <a-button type="primary" @click="closeModal">OK</a-button>
    </a-row>
  </a-modal>
</template>

<script>
import DefaultLabelTab from '@/views/apps/referral-program/components/DefaultLabelTab.vue'
import { Empty } from 'ant-design-vue'
import { subscribe, unsubscribe } from '@/composables/keydownEvent.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    languagesUsed: {
      type: Array,
      default: () => [],
    },
    selectedConditions: {
      type: [Object, Array],
      default: null,
    },
  },
  components: {
    DefaultLabelTab,
    Empty,
  },
  data: () => ({
    showModal: false,
    translations: [],
    items: [],
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    hasItems() {
      return !!this.selectedConditions?.length
    },
  },
  methods: {
    templateDataFilling() {
      if (!this.hasItems) {
        return
      }

      const groupedItems = {}

      this.selectedConditions.forEach(item => {
        const langId = item.language_id
        if (!groupedItems[langId]) {
          groupedItems[langId] = {
            language_id: langId,
            tab_name: this.languagesUsed.find(lang => lang.value === langId)?.name || '',
            is_default: this.languagesUsed.find(lang => lang.value === langId)?.is_default || false,
            items: [],
          }
        }
        groupedItems[langId].items.push({ name: item.name })
      })

      this.translations = Object.values(groupedItems).sort((a, b) => b.is_default - a.is_default)
    },
    clearForm() {
      this.translations = []
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.clearForm()
      }, 500)
    },
  },
  mounted() {
    this.templateDataFilling()
    subscribe(this.closeModal)
  },
  beforeDestroy() {
    unsubscribe()
  },
}
</script>

<style lang="scss">
.view-add-condition-modal {
  .tab-content-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 500px;
    overflow-y: scroll;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #262626;
  }

  .ant-tabs-card > .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    padding: 16px 8px 8px;
    border-right: 1px solid #e4e9f0;
    border-bottom: 1px solid #e4e9f0;
    border-left: 1px solid #e4e9f0;
    border-radius: 0 0 4px 4px;
  }

  .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
    margin-right: 0 !important;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
